module.exports = __webpack_public_path__ + "static/media/user.b9214cd4.png";